// extracted by mini-css-extract-plugin
export var changeIcon = "_57-4";
export var container = "_57-0";
export var divider = "_57-7";
export var externalLinkIcon = "_57-1";
export var green = "_57-5";
export var helpCircleIcon = "_57-3";
export var iconButton = "_57-2";
export var red = "_57-6";